import { Attributes, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

export class DwtConfigValues extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Attributes.Display("SARS Nature Of Person")
    @Attributes.Nullable()
    public sarsNatureOfPersonId: number | null = null;

    @Rules.StringLength(150)
    public registeredName: string = "";

    @Rules.StringLength(150)
    public tradingName: string = "";

    @Rules.StringLength(100)
    public registrationNumber: string = "";

    @Rules.StringLength(100)
    public incomeTaxRefNo: string = "";

    public useForDividendDeclarant: boolean = false;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Dwt Config Values";
    }
}

export class WithholdingAgentConfigValues extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.StringLength(50)
    public withholdingAgentRefNumber: string = "";

    @Rules.StringLength(150)
    public beneficiaryName: string = "";

    @Rules.StringLength(50)
    public beneficiaryTaxReferenceNumber: string = "";

    @Rules.StringLength(50)
    public beneficiaryPhysicalAddress: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Withholding Agent Config Values";
    }
}

export class ReportTextValues extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    public liquidityLadderNotes: string = "";

    // Client only properties / methods
}

export class ReportingConfigValues extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Attributes.ChildObject(DwtConfigValues, true)
    public dwtConfig: DwtConfigValues = new DwtConfigValues();

    @Attributes.ChildObject(WithholdingAgentConfigValues, true)
    public withholdingAgentConfig: WithholdingAgentConfigValues = new WithholdingAgentConfigValues();

    @Attributes.ChildObject(ReportTextValues, true)
    public reportTextConfig: ReportTextValues = new ReportTextValues();

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Reporting Config Values";
    }
}

